import { render, staticRenderFns } from "./AssignedCreate.vue?vue&type=template&id=3c8b266a"
import script from "./AssignedCreate.vue?vue&type=script&lang=js"
export * from "./AssignedCreate.vue?vue&type=script&lang=js"
import style0 from "./AssignedCreate.vue?vue&type=style&index=0&id=3c8b266a&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports